if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
        items: this.querySelectorAll('a'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.isClosedByFocusOut = false;
      this.elements.items.forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
      setTimeout(() => {
        this.closedByFocusOut = false;
      }, 200);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
      this.hidePanel();
      event.stopPropagation();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      if (this.closedByFocusOut) return;
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const isChild = this.elements.panel.contains(event.relatedTarget) || this.elements.button.contains(event.relatedTarget);
      if (!event.relatedTarget || !isChild) {
        this.closedByFocusOut = true;
        this.hidePanel();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);

  if (!customElements.get('localization-disclosure')) {
    class LocalizationDisclosure extends LocalizationForm {
      constructor() {
        super();
        this.elements = {
          ...this.elements,
          ...{
            selectedItem: this.querySelector('span.disclosure__selected-item'),
          },
        };
      }

      selectItem(currentTarget) {
        this.elements.items.forEach((item) => {
          item.classList.remove('disclosure__link--active');
          item.setAttribute('aria-current', 'false');
        });
        currentTarget.classList.add('disclosure__link--active');
        currentTarget.setAttribute('aria-current', 'true');
        this.elements.selectedItem.textContent = currentTarget.textContent;
      }

      onItemClick(event) {
        event.preventDefault();
        this.elements.input.value = event.currentTarget.dataset.value;
        this.selectItem(event.currentTarget);
        this.hidePanel();
      }
    }
    customElements.define('localization-disclosure', LocalizationDisclosure);
  }
}
